import { IonPage } from '@ionic/react';
import styled from 'styled-components';
import { SPACE } from '$gstyles';
import { mobileStyle } from '$gstyles/utils';

export const IonPageWrapper = styled(IonPage)`
  ion-content {
    padding: ${SPACE.LARGE};
  }
  .MuiTableRow-head {
    border-bottom: 1px solid #ccc;
  }
  .MuiTableCell-root.action button {
    padding-top: 6px;
    padding-bottom: 6px;
  }
  .action {
    button {
      padding: 6px;
    }
  }
  .available {
    margin-left: ${SPACE.SMALL};
  }
  input.qty {
    width: 40px;
    padding: 4px;
    text-align: center;
  }
  button.add {
    font-size: 1.3rem;
    width: 60px;
    .MuiButton-endIcon {
      margin-left: 4px;
      margin-right: -4px;
    }
  }
  button.added {
    min-width: 80px;
    display: none;
  }
  .cart-add-enter-active {
    button.add {
      display: none;
    }
    button.added {
      display: inline-flex;
    }
  }
  ${mobileStyle(`
    ul.list li {
      .image, .image img, .image > div{
        max-height: 48px !important;
        max-width: 48px !important;
      }
      .action {
        width: 80px;
      }
    }
    button.MuiButtonBase-root.add {
      width: 80px;
    }
  `)}
`;
